// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-content {
    min-width: 300px;
    max-width: 500px;
    min-height: 60px;
    border-radius: 6px;
}

.message-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    line-height: 1.6;
    padding: 10px 0;
}

.message-warning {
    background-color: #fff3cd;
    border: 1px solid #ffe69c;
    border-left: 4px solid #f0ad4e;
    padding: 8px 12px;
}

.message-title-warning {
    color: #7a5a00;
}

mat-dialog-actions {
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/message-dialog/message-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".message-content {\n    min-width: 300px;\n    max-width: 500px;\n    min-height: 60px;\n    border-radius: 6px;\n}\n\n.message-text {\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    line-height: 1.6;\n    padding: 10px 0;\n}\n\n.message-warning {\n    background-color: #fff3cd;\n    border: 1px solid #ffe69c;\n    border-left: 4px solid #f0ad4e;\n    padding: 8px 12px;\n}\n\n.message-title-warning {\n    color: #7a5a00;\n}\n\nmat-dialog-actions {\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
